import { BetSlipFragment } from "../../graphql/core-types";
import { calculatePotentialPayout } from "../../helpers/bet-line-helpers";
import { formatCurrency } from "../../helpers/currency";
import { formatTimeAgo } from "../../helpers/time-ago";
import { GameIcon } from "../game-icon/game-icon";
import { summariseLegGroup, useBetLegs } from "./use-bet-legs";

export const PendingBetRow = ({ betSlip, now }: { betSlip: BetSlipFragment, now: number }) => {
  const { gameName, legGroups } = useBetLegs(betSlip)

  const summary = legGroups.map(summariseLegGroup).join(' · ')

  return (
    <div className="bet_list__pending_row">
      <GameIcon systemId={gameName} size={20} />
      <div className="bet_list__pending_details">
        <span className="bet_list__pending_summary pl-fontXS">{summary}</span>
        <span className="bet_list__pending_meta">
          <span className="bet_list__pending_time pl-fontXS">{formatTimeAgo(betSlip.insertedAt, now)}</span>
        </span>
      </div>
      <div className="bet_list__pending_payout">
        <span className="bet_list__pending_payout_label pl-fontXS">Win up to</span>
        <span className="bet_list__pending_payout_value pl-fontSContrast">{formatCurrency(calculatePotentialPayout(betSlip))}</span>
      </div>
    </div>
  )
}
